import styles from './EdroloLogo.scss';
import urlResolver from 'edrolo/utils/URLResolver';
import PT from 'prop-types';

const EdroloLogo = ({ trackingOrigin }) => (
  <a
    className={styles.edroloLogo}
    href={urlResolver.reverse('courses-page')}
    onClick={() =>
      global.analytics.track('clicked edrolo shield logo', {
        origin: trackingOrigin,
      })
    }
  />
);

EdroloLogo.propTypes = {
  trackingOrigin: PT.string,
};

export default EdroloLogo;
